// Generated by /client/scripts/generate-icon-components.mjs
// DO NOT EDIT DIRECTLY

import type React from "react";

import wifiIcon from "@/assets/icons/wifi.svg";

import { Icon, type IconProps } from "../Icon/Icon";

type WifiIconProps = Omit<IconProps, "name">;

export function WifiIcon(props: WifiIconProps): React.ReactNode {
  return <Icon name={wifiIcon} {...props} />;
}
